export default function ImageWatermark({
  logoSrc = '/logos/logo.svg',
  className = '',
}) {
  return (
    <div
      aria-hidden="true"
      className={`pointer-events-none absolute inset-0 z-30 flex items-center justify-center ${className}`.trim()}
    >
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        src={logoSrc}
        alt=""
        className="select-none grayscale opacity-20 w-[400px] max-w-[80%] h-auto"
      />
    </div>
  );
}
